import type {
  Claim,
  ClaimListParams,
  ClaimListResponse,
  CreateClaimRequest,
  TransitionClaimRequest,
} from '@/types/api/claim';
import apiClient from './axios.config';

const CLAIMS_ENDPOINT = '/claims';

export const claimApi = {
  list: async (params?: ClaimListParams): Promise<ClaimListResponse> => {
    const { data } = await apiClient.get<ClaimListResponse>(CLAIMS_ENDPOINT, { params });
    return data;
  },

  getById: async (id: string): Promise<{ data: Claim }> => {
    const { data } = await apiClient.get<{ data: Claim }>(`${CLAIMS_ENDPOINT}/${id}`);
    return data;
  },

  create: async (body: CreateClaimRequest): Promise<{ data: Claim }> => {
    const { data } = await apiClient.post<{ data: Claim }>(CLAIMS_ENDPOINT, body);
    return data;
  },

  transition: async (id: string, body: TransitionClaimRequest): Promise<{ data: Claim }> => {
    const { data } = await apiClient.patch<{ data: Claim }>(
      `${CLAIMS_ENDPOINT}/${id}/status`,
      body
    );
    return data;
  },
};

export default claimApi;
